import billRequestApi from '@/api/billRequest/billRequestApi.js';

export default {
	name: 'bill-request',
	mixins: [],
	extends: {},
	components: {},
	props: [],
	data() {
		return {
		};
	},
	computed: {
		
	},
	watch: {},
	created() {},
	mounted() {
		this.init();
	},
	updated() {},
	beforeDestroy() {},
	methods: {
		async init() {
			// 權限驗證
			await billRequestApi.permissionValidation();
		},

		async applyBillRequest(billType) {
			this.$router.push({ name: 'bill-request-apply', query: { billType: billType } });
		}
	},
};



// WEBPACK FOOTER //
// ./src/components/billRequest/billRequest.js